import _cloneDeep from 'lodash/cloneDeep'
import _isEqual from 'lodash/isEqual'
import { eventBus } from 'frontend/communications/eventBus'
import { getAlertsStats,
  getStandardCollectedStats,
  getStandardStats,
  getTop5AlertsStats } from 'frontend/communications/stats'

const stateObj = {
  standardsStats: null,
  alertsStats: null,
  indicators: {},
  top5AlertsStats: null,
  standardsCollectedStats: {
    data: null,
    filters: null,
    promise: null,
  },
}

const getters = {
  standardsStats (state) {
    return state.standardsStats
  },
  standardsCollectedStats (state) {
    return state.standardsCollectedStats.data
  },
  alertsStats (state) {
    return state.alertsStats
  },
  getDynamicIndicator: (state) => (key) => {
    return state.indicators[key]
  },
  dynamicIndicatorExist: (state) => (key) => {
    return state.indicators.hasOwnProperty(key)
  },
  top5AlertsStats (state) {
    return state.top5AlertsStats
  },
}

const mutations = {
  setStandardsStats (state, standardsStats) {
    state.standardsStats = standardsStats
  },
  setStandardsCollectedStats (state, standardsCollectedStats) {
    state.standardsCollectedStats = standardsCollectedStats
  },
  setAlertsStats (state, alertsStats) {
    state.alertsStats = alertsStats
  },
  setTop5AlertsStats (state, top5AlertsStats) {
    state.top5AlertsStats = top5AlertsStats
  },
  setDynamicIndicator (state, {name, value}) {
    state.indicators[name] = value
  },
  resetDynamicIndicator (state, value) {
    state.indicators = value
  },
}

const actions = {
  resetStats ({ commit }) {
    commit('setStandardsStats', null)
    commit('resetDynamicIndicator', {})
  },
  fetchStandardsStats ({ commit }, payload) {
    return getStandardStats(
      payload.perimeters,
      payload.frequency,
      payload.from,
      payload.to
    ).then(data => {
      commit('setStandardsStats', data)
      return data
    })
  },
  fetchStandardsCollectedStats ({ commit, state }, payload) {
    const stats = { ...state.standardsCollectedStats }
    if (stats.promise && _isEqual(payload, stats.filters)) {
      return stats.promise
    }
    stats.filters = _cloneDeep(payload)
    stats.promise = getStandardCollectedStats(
      payload.perimeters,
      payload.frequency,
      payload.from,
      payload.to
    ).then(data => {
      stats.promise = null
      stats.data = data
      commit('setStandardsCollectedStats', stats)
    })
    commit('setStandardsCollectedStats', stats)
    return stats.promise
  },
  fetchAlertsStats ({ commit }, payload) {
    eventBus.fetchingAlertsStats(true)
    getAlertsStats(payload).then(data => {
      commit('setAlertsStats', data)
      eventBus.fetchingAlertsStats(false)
    })
  },
  fetchTop5AlertsStats ({ commit }, payload) {
    eventBus.fetchingTop5AlertsStats(true)
    getTop5AlertsStats(payload).then(data => {
      commit('setTop5AlertsStats', data)
      eventBus.fetchingTop5AlertsStats(false)
    })
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
